import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'

// 导入翻译文件
import translationEN from './locales/en/translation.json'
import translationZH from './locales/zh/translation.json'
import translationES from './locales/es/translation.json'
import translationJP from './locales/jp/translation.json'
import translationFR from './locales/fr/translation.json'
import translationDE from './locales/de/translation.json'
import translationIT from './locales/it/translation.json'
import translationRU from './locales/ru/translation.json'

const resources = {
  en: {
    translation: translationEN,
  },
  zh: {
    translation: translationZH,
  },
  es: {
    translation: translationES,
  },
  jp: {
    translation: translationJP
  },
  fr: {
    translation: translationFR
  },
  de: {
    translation: translationDE
  },
  it: {
    translation: translationIT
  },
  ru: {
    translation: translationRU
  },
};

// 从 localStorage 获取保存的语言，如果没有则使用默认语言
const savedLanguage = localStorage.getItem('i18nextLng') || 'en';
//console.error(savedLanguage)
i18n
  // 使用 i18next-http-backend
  .use(Backend)
  // 检测用户语言
  .use(LanguageDetector)
  // 将 i18n 实例传递给 react-i18next
  .use(initReactI18next)
  // 初始化 i18next
  .init({
    resources,
    lng: savedLanguage, // 默认语言
    fallbackLng: 'en', // 备用语言
    debug: false,//process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false, // 不转义 HTML
    },
  });

export default i18n; 